import React, { useState, useEffect } from 'react';
import Styles from './device-report-modal.module.scss';
import SiriusModal from '@lingxi-common-component/sirius-ui/SiriusModal';
import DeviceReportTip from './device-report-tip';
import DeviceReportModal from '@web-setting/Account/device-report/device-report-modal';
import DeviceReportResult from '@web-setting/Account/device-report/report-result';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis, transferServerDeviceToLocalDevice } from 'api';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const DeviceReportLoginModal = props => {
    const { onClose } = props;
    const [tipVisible, setTipVisible] = useState(false);
    const [reportVisible, setReportVisible] = useState(false);
    const [isReporting, setIsReporting] = useState(false);
    const [deviceInfo, setDeviceInfo] = useState(null);
    useEffect(() => {
        loginApi.getSecDeviceInfo().then(res => {
            if (!res || res.status === 'ERROR') {
                SiriusMessage.error('获取设备信息出错');
                return;
            }
            const serverDevice = res.data;
            if (serverDevice) {
                const localDeviceModal = transferServerDeviceToLocalDevice(serverDevice);
                setDeviceInfo(localDeviceModal);
            }
            if (res.status === 'REPORTING') {
                setIsReporting(true);
            }
            if (res.status === 'NEED-REPORT') {
                setIsReporting(false);
                setTipVisible(true);
            }
        });
    }, []);
    if (!deviceInfo) {
        return null;
    }
    return (React.createElement(SiriusModal, { width: 640, onCancel: () => {
            onClose && onClose();
        }, visible: true, footer: null, maskClosable: false },
        React.createElement("div", { className: Styles.mainWrapper },
            !isReporting && tipVisible && (React.createElement(DeviceReportTip, { onReport: () => {
                    setReportVisible(true);
                } })),
            isReporting ? (React.createElement(DeviceReportResult, { hideSuccess: false, deviceMacInfo: deviceInfo, onCloseModal: () => {
                    onClose && onClose();
                } })) : null),
        !isReporting && reportVisible ? (React.createElement(DeviceReportModal, { reporting: false, isReported: false, isLogin: true, onCloseModal: () => {
                setReportVisible(false);
            }, onReportSuccess: (newDeviceInfo) => {
                setDeviceInfo(newDeviceInfo);
                setReportVisible(false);
                setIsReporting(true);
            }, noShowResultInModal: true, deviceMacInfo: deviceInfo })) : null));
};
export default DeviceReportLoginModal;
